import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-auth-event-invalid-token',
  templateUrl: './auth-event-invalid-token.component.html',
  styleUrls: ['./auth-event-invalid-token.component.scss']
})
export class AuthEventInvalidTokenComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
